import React, { useRef, useContext, forwardRef, useEffect } from "react"
import { Container, Sprite, AnimatedSprite, useTick } from "@inlet/react-pixi"
import { TextureContext } from "utils/texture-context"
import { lerp, clamp, easeInOut } from "utils/math"
import { icons } from "global.js"

const Anticipation = ({ item, counter, x, y, ...props }) => {
  const time = useRef(0)
  const ref = useRef()

  const context = useContext(TextureContext)
  const textures = context[`anticipation-spritesheet.json`]

  useTick((delta, x) => {
    time.current += x.elapsedMS
  })

  return (
    <Container x={x} y={y}>
      <AnimatedSprite
        textures={textures}
        width={60}
        height={180}
        isPlaying={true}
        animationSpeed={0.8}
      />
    </Container>
  )
}

export default Anticipation
